<template>
  <el-container class="product-intro-container">
    <el-header class="product-intro-header">
      <el-row>
        <el-col :span="2">
          <img @click="goToHome()"
               src="~assets/img/logo.png"
               alt="图片无法显示"
               style="height: 42px; cursor: pointer;object-fit: contain" />
        </el-col>
        <el-col :span="18">
          <div class>当前目的地</div>
        </el-col>
        <!-- 个人中心 -->
        <el-col :span="4">
          <div style="display: flex; height: 40px; margin-top: 10px">
            <a class="J_AppLink"
               href="/account/settings">
              <img src="http://img4.imgtn.bdimg.com/it/u=3701847413,2165986719&fm=11&gp=0.jpg"
                   style="
                  height: 40px;
                  width: 40px;
                  border-radius: 40px;
                  margin-right: 8px;
                " />
            </a>
            <div>
              <p style="
                  height: 20px;
                  line-height: 20px;
                  color: rgb(51, 51, 51);
                  display: flex;
                  align-items: center;
                ">
                <span title="星球玩家俱乐部"
                      style="
                    display: inline-block;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    max-width: 150px;
                  ">{{userName}}</span>
              </p>

              <p @click="handleLogout()"
                 style="
                  height: 20px;
                  line-height: 20px;
                  font-size: 12px;
                  color: rgb(153, 153, 153);
                  cursor: pointer;
                ">
                旅行规划师 | 退出
                <i class="next-icon next-icon-arrow-down-filling next-icon-xxs"
                   style="margin-left: 3px; color: rgb(83, 102, 123)"></i>
              </p>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-header>
    <!-- 头部over -->
    <el-container class="main-background">
      <!-- ----------------------------左侧导航---------------------------- -->
      <el-aside width="auto"
                class="product_aside">
        <!-- 产品基本信息栏 -->
        <el-card shadow="never"
                 class="card-header-style"
                 :body-style="{ padding: '15px' }"
                 style="height: auto; width: 400px; border-radius: 5px">
          <div slot="header"
               class="header-product-title">
            {{ spu_name }}
            <!-- 返回产品列表 -->
            <el-button @click="goBackProList()"
                       style="
                color: white;
                float: right;
                margin-right: 10px;
                padding: 2px 0;
              "
                       type="text">返回</el-button>
          </div>
          <div class="content-left-info">
            <b>目的地：</b>

            <span style="margin-left: 5px"
                  v-for="(locitem, index) in spu_dest"
                  :key="index"
                  size="mini"
                  type="info">{{ locitem }}</span>
            <!-- <el-tag
                style="margin-left: 5px"
                v-for="(locitem,index) in spu_dest"
                :key="index"
                size="mini"
                type="info"
            >{{locitem}}</el-tag>-->
          </div>
          <div class="content-left-info">
            <b>产品ID:</b>
            {{ spu_id }}
          </div>
          <div class="content-left-info">
            <b>外部编号：</b>
            {{ out_spu_id }}
          </div>
          <div class="content-left-info">
            <b>库存类型：</b>
            <div style="margin-top:10px">
              <el-switch v-model="stock_type"
                         :active-value="false"
                         :inactive-value="true"
                         active-color="#58D68D"
                         inactive-color="#3C83E7"
                         active-text="日期库存"
                         inactive-text="固定库存">
              </el-switch>
            </div>

          </div>
        </el-card>

        <!-- 套餐信息 / style="height:100%;width:400px;border-radius:3px" -->
        <el-card shadow="never"
                 class="card-header-style"
                 :body-style="{ padding: '10px 20px' }"
                 style="margin-top: 10px; width: 400px; border-radius: 5px">
          <div slot="header"
               style="display: float">
            <span>可选套餐</span>
            <el-button @click="changeBatchPrice(spu_id)"
                       style="
                color: white;
                float: right;
                margin-right: 10px;
                padding: 2px 0;
              "
                       type="text">批量改价</el-button>
          </div>
          <draggable v-model="dynamicTags"
                     animation="1000"
                     filter=".unmover"
                     @end="dragFinish">
            <div class="select_skus_item"
                 @click="click_sku_name(sku.sku_id)"
                 v-for="(sku, index) in skus"
                 :key="index">
              <el-card :body-style="{ padding: '10px' }"
                       shadow="hover">
                <el-tag style="margin-right: 10px"
                        size="mini"
                        effect="plain">{{
                  sku.sku_status
                }}</el-tag>
                {{ sku.sku_name }}
                <span v-if="sku.price_range"
                      style="float: right; color: #ff5421">¥：{{ sku.price_range / 100 }}</span>

                <div class="additional_style">
                  外部套餐编号：{{ sku.out_sku_id }}
                </div>
              </el-card>
            </div>
          </draggable>
          <el-button @click="addSkuItem"
                     plain
                     type="primary"
                     style="width: 100%; margin-bottom: 10px">添加套餐</el-button>
        </el-card>
        <!-- 服务商信息 / style="height:100%;width:400px;border-radius:3px" -->
        <el-card shadow="never"
                 class="card-header-style"
                 style="margin-top: 10px; width: 400px; border-radius: 5px">
          <div slot="header"
               class="clearfix">
            <span>服务商基本信息</span>

            <el-button v-if="operator_info_has"
                       style="color: white; float: right; padding: 2px 0"
                       type="text"
                       @click="changeOperatorInfor()">添加</el-button>
            <el-button v-else
                       style="color: white; float: right; padding: 2px 0"
                       type="text"
                       @click="changeOperatorInfor()">编辑</el-button>
          </div>
          <div v-if="operator_info_has">未添加服务商信息</div>
          <div v-else>
            <el-avatar shape="square"
                       :size="100"
                       :fit="operator_fit"
                       :src="operator_url"><template v-if="operator_info.operator_avatar == ''"
                        slot="default">
                <img src="https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png"
                     alt="" />
              </template>
            </el-avatar>
            <div class="content-left-operate">
              <b>服务商名称：</b>
              {{ operator_info.operator_name }}
              <div class="additional_style">
                当地名或别称：{{ operator_info.operator_loc_name }}
              </div>
            </div>
            <div class="content-left-operate">
              <b>服务商所在地：</b>

              <span style="margin-right: 5px"
                    class="dest-tag"
                    v-for="(dest, index) in operator_info.operator_dest"
                    :key="index">{{ dest }}</span>
            </div>
            <div class="content-left-operate">
              <b>地址：</b>
              {{ operator_info.operator_address }}
            </div>
            <div class="content-left-operate">
              <b>联系人：</b>
              {{ operator_info.operator_manager }}
            </div>
            <div class="content-left-operate">
              <b>联系电话：</b>
              {{ operator_info.operator_mobile }}
            </div>
            <div class="content-left-operate">
              <b>更多介绍：</b>
              {{ operator_info.operator_intro }}
            </div>
          </div>
          <!-- <div class="content-left-operate">地址：</div>
            <div class="content-left-operate">联系人：</div>
            <div class="content-left-operate">联系电话：</div>
          <div class="content-left-operate">更多介绍：</div>-->
          <!-- <div
              class="content-left-operate"
              v-for="(info,key,index) in operator_info"
              :key="index"
          >{{info}}</div>-->
        </el-card>
        <!-- 位置信息 -->
        <el-card shadow="never"
                 class="card-header-style"
                 :body-style="{ padding: '10px 20px' }"
                 style="margin-top: 10px; width: 400px; border-radius: 5px">
          <div slot="header"
               style="display: float">
            <span>位置</span>
            <el-button @click="addSpuPoiInfo"
                       style="
                color: white;
                float: right;
                margin-right: 10px;
                padding: 2px 0;
              "
                       type="text">配置位置信息</el-button>
          </div>
          <div>
            <!-- <img src="~/assets/img/WechatIMG1824.png" alt /> -->
            <location-product></location-product>
            <el-dialog :visible.sync="showLocationOnMap"
                       width="50%">
              <select-or-add-poi-list @submitPoi="bandNewPoi"
                                      @closeSubmitPOI="closeSubmitPOI"
                                      :proplat="lat"
                                      :proplng="lng"></select-or-add-poi-list>
            </el-dialog>
          </div>
        </el-card>

        <!-- 更新信息 / style="height:100%;width:400px;border-radius:3px" -->
        <el-card shadow="never"
                 class="card-header-style"
                 style="margin-top: 10px; width: 400px; border-radius: 5px">
          <div slot="header"
               class="clearfix">
            <span>产品更新记录</span>
            <el-button style="color: white; float: right; padding: 2px 0"
                       type="text">查看更多</el-button>
          </div>
          <div class="content-left-operate">
            <b>最新更新时间：</b>
          </div>
          <div class="content-left-operate">
            <b>最新更新内容：</b>
          </div>
        </el-card>
        <!-- 删除产品 -->
        <el-card shadow="never"
                 class="card-header-style"
                 style="
            text-align: center;
            margin-top: 10px;
            width: 400px;
            border-radius: 5px;
          ">
          <el-button @click="deleteProduct"
                     type="primary"
                     style="width: 100%; padding: 10px">删除商品</el-button>
        </el-card>
        <!-- 侧边栏结束 -->
      </el-aside>
      <!-- ------------------------------------------ 内容区 ------------------------------------------ -->
      <!-- 产品介绍 与套餐介绍 -->
      <el-main class="product_intro_contain">
        <!-- 产品信息的 维护与修改 -->
        <spu-modify ref="spu_modify"
                    :visable_spu_modify="spu_modify"></spu-modify>
        <div v-if="visable_pro_info">
          <!-- 回到顶部 -->
          <el-backtop target=".product_intro_contain"></el-backtop>
          <!-- ---------------------------------------- 内容区:产品介绍 -------------------------------------- -->
          <el-card class="main_product_info"
                   shadow="never"
                   :body-style="{ padding: '30px 50px' }">
            <!-- 修改标题 -->
            <div slot="header"
                 class="clearfix">
              <span class="el-icon-collection"
                    style="
                  color: #ff5421;
                  font-size: 15px;
                  font-weight: normal;
                  margin-top: 5px;
                ">产品介绍</span>
              <el-button @click="spu_info_modify()"
                         style="float: right; padding: 2px 0"
                         type="text">编辑</el-button>
            </div>
            <!-- 更新日期、添加人、产品链接的复制 -->
            <div style="margin-bottom: 15px">
              <span class="el-icon-time"
                    style="color: lightgray">更新日期：2020年09月07日 操作人：answer</span>
              <span class="el-icon-document-copy"
                    style="float: right; color: lightgray; margin-left: 10px">复制链接</span>
              <div style="border-top: 1px solid lightgray"></div>
            </div>
            <!-- 内容部分 -->
            <p style="width: 100%"
               v-html="spu_detail"></p>
          </el-card>

          <!-- ---------------------------------------- 内容区:套餐 -------------------------------------- -->
          <el-card v-for="(pkg, index) in skus"
                   v-bind:id="pkg.sku_id"
                   :key="index"
                   class="main_product_info"
                   shadow="never"
                   :body-style="{ padding: '10px 50px 30px 50px' }">
            <div slot="header"
                 class="clearfix">
              <span class="el-icon-notebook-2"
                    style="
                  color: #ff5421;
                  font-size: 15px;
                  font-weight: normal;
                  margin-top: 5px;
                ">
                {{ pkg.sku_name }}
                <span style="
                    color: #d7d7d7;
                    padding-left: 20px;
                    font-size: 5px;
                    font-weight: lighter;
                  ">ID:{{ pkg.sku_id }}</span>
              </span>
              <!-- ----------- 菜单 ----------- -->
              <div style="float: right; margin-right: 10px; padding: 2px 0">
                <el-dropdown @command="clickDropdownButtion"
                             trigger="click">
                  <span class="el-dropdown-link el-icon-more"></span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="pkg.sku_id">添加场次</el-dropdown-item>
                    <el-dropdown-item :command="{ command: 'changePkgName', id: pkg.sku_id }">修改套餐名称</el-dropdown-item>
                    <el-dropdown-item :command="{ command: 'addPriceForSku', id: pkg.sku_id }">修改/添加价格</el-dropdown-item>
                    <el-dropdown-item :command="{
                        command: 'bandTravellerInfo',
                        id: pkg.sku_id,
                      }">绑定出行人模版</el-dropdown-item>
                    <el-dropdown-item :command="{ command: 'bandResTemplate', id: pkg.sku_id }">绑定预定信息模版</el-dropdown-item>
                    <el-dropdown-item :command="{
                        command: 'changeSkuStauts',
                        id: pkg.sku_id,
                      }">下架/上架</el-dropdown-item>
                    <!-- 删除/product/delete_sku -->
                    <el-dropdown-item :command="{
                        command: 'deleteSku',
                        id: pkg.sku_id,
                      }">删除该套餐</el-dropdown-item>
                    <el-dropdown-item disabled>预定</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <!-- -----------套餐价格-----------  -->
            <div class="package_price_area">
              <!-- 固定价格 -->

              <div>原价：{{ (pkg.price_range / 100).toFixed(2) }}</div>
              <div>售价：{{ (pkg.sell_price_range / 100).toFixed(2) }}</div>
              <div v-if="pkg.net_price_range">底价：{{ (pkg.net_price_range / 100).toFixed(2) }}</div>
              <!-- 日历价格价格 -->
              <div v-if="stock_type == 0">
                <div>库存到期日期：{{ pkg.expiry_date }}</div>
              </div>
            </div>
            <!-- -----------套餐介绍  测试组件 editormodify组件 内容 与编辑页 ----------- -->
            <div style="margin-top: 20px"></div>
            <editor-content title="套餐介绍："
                            :attribuite="pkg.sku_id"
                            @save="saveSkuInfoButton"
                            :show_content="`${pkg.sku_info}`"></editor-content>
            <!-- -----------场次的添加与修改----------- -->
            <add-and-edit-tag :attribuite="pkg.sku_id"
                              :sku_more_info="pkg.more_info"
                              ref="addTag"></add-and-edit-tag>
            <!-- 费用包含 -->
            <div style="margin: 20px 0 30px 0">
              <input-area-modify title="费用包含："
                                 button_name="编辑"
                                 :attribuite="pkg.sku_id"
                                 @save="saveFeeIncludeButton"
                                 :show_content="`${pkg.fee_include}`"></input-area-modify>
            </div>
            <!---------------------------------------- 接送信息 编辑套餐 ---------------------------------------->
            <traffic-content :attribuite="pkg.sku_id"
                             :traffic_type_prop="pkg.traffic_type"
                             :traffic_info_prop="pkg.traffic_info"></traffic-content>
            <div style="margin-bottom: 50px"></div>
            <!-- 日历库存 -->
            <!-- <div style="margin-top:50px;">
              <span style="  font-size: 15px;font-weight: bold;margin-bottom: 10px;">库存与价格：</span>
              <div></div>
            </div>
            <div style="height:100px"></div>-->
            <!-- 可选附加项 -->
            <div style="margin-bottom: 30px">
              <config-and-select-addition :spu_id="spu_id"
                                          :sku_id="pkg.sku_id"
                                          :skuAdditionList="pkg.sku_additions"
                                          title="可选附加项:"
                                          button_name="选取附加项"
                                          :attribuite="pkg.sku_id"></config-and-select-addition>
            </div>
            <!-- 退改说明 选择 -->
            <button-content title="退改说明："
                            button_name="编辑"
                            :show_content="`${pkg.refund_info}`"
                            :sku_refund_id="pkg.refund_info_id"
                            :refundData="refund_data_list"
                            ref="button_content"
                            :attribuite="pkg.sku_id"
                            @choice="showRefundChoice"></button-content>

            <!-- 确认单/ 预定/须知/说明 -->
            <booking-info-content title="预定须知："
                                  button_name="编辑"
                                  :upLoadImgAddress="`${$ip}/add_image?key_name=traver_sku_introduce_${pkg.sku_id}`"
                                  :show_content="`${pkg.confirm_info}`"
                                  :attribuite="pkg.sku_id"
                                  @save="saveConfirmInfo"></booking-info-content>
          </el-card>
          <!-- 素材中心 -->
          <el-card style="margin-bottom: 100px"
                   shadow="never">
            <!-- 素材标题 -->
            <div slot="header"
                 class="clearfix">
              <span>素材中心</span>
              <el-button style="float: right; padding: 2px 0"
                         type="text">批量下载</el-button>
              <el-button style="float: right; margin-right: 10px; padding: 2px 0"
                         type="text">添加</el-button>
            </div>
            <!-- 素材 -->
            <div style="margin-bottom: 100px"></div>
          </el-card>
          <el-divider>到底还是你</el-divider>
        </div>
      </el-main>
      <!-- -------------------------------------- 弹出对话框部分 -------------------------- -->
      <!-- 添加套餐 -->
      <el-dialog @close="closeAddSkuForm"
                 title="添加套餐"
                 :visible.sync="addSkuFormVisible">
        <el-form :rules="rules"
                 :model="addSkuForm"
                 ref="addSkuDialog">
          <el-form-item label="套餐名称"
                        :label-width="addSkuFormLabelWidth"
                        prop="sku_name">
            <el-input size="mini"
                      style="width: 300px"
                      v-model="addSkuForm.sku_name"
                      autocomplete="off"
                      maxlength="30"
                      show-word-limit
                      prop="sku_name"></el-input>
          </el-form-item>
          <el-form-item label="套餐编码"
                        :label-width="addSkuFormLabelWidth"
                        prop="out_sku_id">
            <el-input size="mini"
                      style="width: 200px"
                      v-model="addSkuForm.out_sku_id"
                      autocomplete="off"></el-input>
            <el-link style="margin-left: 10px"
                     @click="creatOutSkuId"
                     :underline="false"
                     type="primary"
                     icon="el-icon-refresh">生成编号</el-link>
          </el-form-item>
          <el-form-item label="套餐介绍"
                        :label-width="addSkuFormLabelWidth"
                        prop="sku_info">
            <el-input size="mini"
                      type="textarea"
                      :autosize="{ minRows: 2, maxRows: 4 }"
                      style="width: 200px"
                      v-model="addSkuForm.sku_info"
                      autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="价格包含"
                        :label-width="addSkuFormLabelWidth"
                        prop="fee_include">
            <el-input size="mini"
                      type="textarea"
                      :autosize="{ minRows: 2, maxRows: 4 }"
                      style="width: 200px"
                      v-model="addSkuForm.fee_include"
                      autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="价格不含"
                        :label-width="addSkuFormLabelWidth"
                        prop="fee_exclude">
            <el-input size="mini"
                      type="textarea"
                      style="width: 200px"
                      v-model="addSkuForm.fee_exclude"
                      autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button size="mini"
                     @click="addSkuFormCancle('addSkuDialog')">取 消</el-button>
          <el-button size="mini"
                     type="primary"
                     @click="addSkuFormConfirm">添加新套餐</el-button>
        </div>
      </el-dialog>
      <!-- 修改套餐名称 -->
      <el-dialog title="修改套餐名称"
                 :visible.sync="changePkgNameFormVisible">
        <el-form :model="changePkgNameForm">
          <el-form-item label="套餐名称"
                        :label-width="changePkgNameLabelWidth">
            <el-input size="mini"
                      style="width: 70%"
                      v-model="changePkgNameForm.sku_name"></el-input>
          </el-form-item>
          <el-form-item label="套餐外部编码"
                        :label-width="changePkgNameLabelWidth">
            <el-input size="mini"
                      style="width: 50%"
                      v-model="changePkgNameForm.out_sku_id"></el-input>
            <el-link style="margin-left: 10px"
                     @click="changeOutSkuId"
                     :underline="false"
                     type="primary"
                     icon="el-icon-refresh">生成编号</el-link>
          </el-form-item>
        </el-form>
        <div slot="footer"
             class="dialog-footer">
          <el-button size="mini"
                     @click="dialogFormVisible = false">取 消</el-button>
          <el-button size="mini"
                     type="primary"
                     @click="changePkgNameConfirm">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 绑定 预定信息模版 -->
      <el-dialog width="80%"
                 title="绑定预定信息模版"
                 :visible.sync="bandResTemplateVisible">
        <band-res-template style="margin-bottom: 10px"
                           :sku_id="band_sku_id"
                           :checkBox="band_res_template_id"
                           :templateData="templateData"
                           :res_template_checked="res_template_checked"
                           @selectResTemplate="selectResTemplate"></band-res-template>
      </el-dialog>
      <!-- 绑定 出行人信息 模版 -->
      <band-traveller-template :sku_id="band_sku_id"
                               :showTravellerTemplate.sync="showTravellerTemplate"
                               :checkTravellerTemplate="band_traveller_template_id"
                               :traveller_template_checked="traveller_template_checked"
                               :template_name="template_name"
                               :template_must_fill_in="template_must_fill_in"
                               :template_one_everyone="template_one_everyone"></band-traveller-template>
      <!-- 产品批量修改库存 和价格 ---->
      <el-dialog custom-class="dialog-add-stock-price"
                 width="90%"
                 title="添加价格规格"
                 @close="closeAddSkuStock"
                 :visible.sync="dialogAddStockPriceProp">
        <price-of-product ref="price_of_product"
                          @closeDealWithOk="closeDealWithOk"
                          :loading_up_price="loading_up_price"
                          :spu_id="spu_id"></price-of-product>
      </el-dialog>
      <!-- 修改服务商信息 -->
      <product-operator ref="formOperatorInfo"
                        :showDialogOperatorInfo.sync="showDialogOperatorInfo"
                        @confirmAddOperator="confirmAddOperator"
                        @choiceProductOperator="choiceProductOperator"
                        :spu_id="spu_id"></product-operator>
    </el-container>
    <!-- 添加套餐固定价格 -->
    <el-dialog title="修改/添加套餐价格"
               :visible.sync="addPriceForSkuDialog"
               width="30%"
               :before-close="handleCloseAddPriceForSkuDialog">
      <span>
        <div style="margin-bottom:10px">
          原价：<el-input v-model="price"></el-input>
        </div>
        <div style="margin-bottom:10px">
          售价：<el-input v-model="sell_price"></el-input>
        </div>
        <div>
          底价：<el-input v-model="net_price"></el-input>
        </div>
      </span>
      <span slot="footer">
        <el-button size="mini"
                   @click="handleCloseAddPriceForSkuDialog">取 消</el-button>
        <el-button size="mini"
                   type="primary"
                   @click="submitNewPriceForSku">更 新</el-button>
      </span>
    </el-dialog>
    <!-- 底部 -->
    <!-- <el-footer height="10px" class="product-intro-footer"></el-footer> -->
  </el-container>
</template>

<script>
import SpuModify from '../../components/common/modify/SpuModify'
import EditorModify from '../../components/common/modify/EditorModify'
import TrafficModify from '../../components/common/modify/TrafficModify'
import InputAreaModify from '../../components/common/modify/InputAreaModify'
import SelectOrAddPoiList from '../../components/map/SelectOrAddPoiList'

// 附加项组件
import ConfigAndSelectAdditon from '../../components/product/ConfigAndSelectAddition'
import RefundModify from '../../components/common/modify/RefundModify'
import BookingInfoModify from '../../components/common/modify/BookingInfoModify'
import SkuStockShow from '../../components/common/stock/SkuStockShow'
import AddStockPrice from '../../components/common/stock/AddStockPrice'
import AddAndEditTag from '../../components/common/modify/AddAndEditTag'
import PriceInput from '../../components/common/input/PriceInput'
import BandResTemplate from '../../components/common/modify/BandResTemplate'
import BandTravellerTemplate from '../../components/common/modify/BandTravellerTemplate'
import ProductOperator from '../../components/product/ProductOperator'
import PriceOfProduct from '../../components/product/PriceOfProduct'
import LocationProduct from '../../components/map/LocationProduct'
// 拖拽
import draggable from 'vuedraggable'

export default {
  name: 'ProductIntro',
  components: {
    draggable,
    SelectOrAddPoiList,
    'spu-modify': SpuModify,
    'editor-content': EditorModify,
    'traffic-content': TrafficModify,
    'input-area-modify': InputAreaModify,
    'button-content': RefundModify,
    'booking-info-content': BookingInfoModify,
    'sku-stock-show': SkuStockShow,
    'add-stock-price': AddStockPrice,
    'config-and-select-addition': ConfigAndSelectAdditon,
    'add-and-edit-tag': AddAndEditTag,
    'input-price': PriceInput,
    'band-res-template': BandResTemplate,
    'band-traveller-template': BandTravellerTemplate,
    'product-operator': ProductOperator,
    'price-of-product': PriceOfProduct,
    'location-product': LocationProduct,
  },
  data() {
    return {
      userName: '',
      // 库存类型
      stock_type: 1,
      addPriceForSkuDialog: false,
      price: null,
      sell_price: null,
      net_price: null,
      change_price_sku_id: null,
      // 拖住：
      dynamicTags: [],
      //
      template_name: '',
      template_must_fill_in: '',
      template_one_everyone: '',
      // 位置
      showLocationOnMap: false,
      lat: '',
      lng: '',
      // 组件的显示
      changePkgNameFormVisible: false, // 修改套餐名称
      showDialogOperatorInfo: false, // 添加/修改服务商信息
      bandResTemplateVisible: false,
      showTravellerTemplate: false,
      visable_pro_info: true,
      spu_modify: false,
      // 修改套餐名称
      changePkgNameLabelWidth: '30%',
      changePkgNameForm: {
        sku_id: '',
        sku_name: '',
        out_sku_id: '',
      },
      // 绑定套餐信息模版
      band_res_template_id: '',
      band_traveller_template_id: 0,
      band_sku_id: 0,
      // 产品数据
      spu_id: null,
      out_spu_id: '',
      spu_name: '',
      category_id: '',
      spu_image: '',
      spu_dest: [],
      spu_dest_id: '',
      spu_dest_pid: [],
      spu_detail: '',
      operator_fit: 'fill',
      // "fill", "contain", "cover", "none", "scale-down",
      operator_url: '',
      operator_info_has: true,
      operator_info: {
        // fits: ["fill", "contain", "cover", "none", "scale-down"],
        operator_avatar: '',
        operator_name: '',
        operator_loc_name: '',
        operator_address: '',
        operator_dest: '',
        operator_intro: '',
        operator_manager: '',
        operator_mobil: '',
      },
      // 修改套餐介绍：
      showAddAndEditTag: false,
      is_editor: false,
      // 批量修改价格
      loading_up_price: false,
      dialogAddStockPriceProp: false,
      test: '',

      // 选择退改规则
      refund_data_list: [
        // {
        //   id:5,
        //   is_checked:5,
        //   refund_info:"xxx"
        // }
      ],
      // 添加sku
      rules: {
        sku_name: [
          { required: true, message: '请输入套餐名称', trigger: 'blur' },
          { min: 3, max: 30, message: '长度在 3 到 30 个字', trigger: 'blur' },
        ],
        out_sku_id: [
          { required: true, message: '请输入外部编号', trigger: 'blur' },
          {},
        ],
      }, //表单规则
      addSkuFormVisible: false,
      addSkuFormLabelWidth: '120px',
      addSkuForm: {
        sku_name: '',
        out_sku_id: '',
        sku_info: '',
        fee_include: '',
        fee_exclude: '',
      },
      // 菜单部分数据
      res_template_checked: [],
      traveller_template_checked: [],
      templateData: [],
      // 获取的sku数据
      skus: [
        // {
        //   sku_id:"",
        //   sku_name:"",
        //   sku_status:"",
        //   sku_info:"",
        //   confirm_info:"",
        //   use_type:"",
        //   expiration_date:"",
        //   fee_exclude:"",
        //   fee_include:"",
        //   refund_info:""
        //   refund_info_id:""
        // }
      ],
    }
  },

  created() {
    this.getProductINtorduce(this.$route.query.spu_id)
  },
  mounted() {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'))
    console.log()
    this.userName = userInfo.userName
  },
  methods: {
    // 拖拽
    dragFinish() {
      console.log('S')
    },
    // 复制文本信息pastContent
    pastContent(event) {
      // console.log(event.target.outerText);
      this.$copyText(event.target.outerText)
        .then((res) => {
          this.$message({
            message: '信息已复制到剪贴板',
            type: 'success',
          })
        })
        .catch((res) => {
          console.log('出错错了')
        })
    },
    // 删除 产品 确认操作 和通知
    deleteProduct() {
      this.$confirm('点击确认即可删除该商品', '确认删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$http
            .get(`/product/delete_product?spu_id=${this.spu_id}`)
            .then((res) => {
              if (res.data.errno == '0') {
                this.$notify({
                  title: '成功',
                  message: res.data.errmsg,
                  type: 'success',
                })
                this.$router.push({ path: '/product_list' })
              } else if (res.data.errno !== '0') {
                this.$notify.error({
                  title: '错误',
                  message: '没有删除成功，可能是数据异常或其他错误',
                })
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    // 返回【产品列表】
    goBackProList() {
      this.$router.push({ path: '/product_list' })
    },
    // 返回【主页】点击logo
    goToHome() {
      this.$router.push({ path: '/home' })
    },
    spu_info_modify() {
      this.visable_pro_info = false
      this.spu_modify = true
      this.$refs.spu_modify.getSpuInfo()
    },
    changeOperatorInfor() {
      // 打开供应商 信息编辑面板
      this.$http
        .get(`/product/get_operator_info?spu_id=${this.spu_id}`)
        .then((res) => {
          // console.log(res);
          const { data, errno, errmsg } = res.data
          if (errno == '0') {
            this.$refs.formOperatorInfo.formOperatorInfo.id = data.id
            this.$refs.formOperatorInfo.imageUrl = data.logo
            this.$refs.formOperatorInfo.formOperatorInfo.name = data.name
            this.$refs.formOperatorInfo.formOperatorInfo.loc_name =
              data.loc_name
            this.$refs.formOperatorInfo.selectDests = data.dest_group
            this.$refs.formOperatorInfo.formOperatorInfo.dest = data.dest_group
            this.$refs.formOperatorInfo.formOperatorInfo.address = data.address
            this.$refs.formOperatorInfo.formOperatorInfo.manager = data.manager
            this.$refs.formOperatorInfo.formOperatorInfo.mobile = data.mobile
            this.$refs.formOperatorInfo.formOperatorInfo.introduce =
              data.introduce
            this.showDialogOperatorInfo = true
          } else if (errno == '4002') {
            this.showDialogOperatorInfo = true
          }
        })
    },
    addSpuPoiInfo() {
      // 编辑位置信息
      this.showLocationOnMap = true
    },
    bandNewPoi(value) {
      // console.log(value)
      // 将 poiid 添加给spu
      this.$http
        .get(`/produce/band_poi_to_spu?spu_id=${this.spu_id}&poi_id=${value}`)
        .then((res) => {
          console.log(res)
          if (res.data.errno == '0') {
            this.$message({
              message: res.data.errmsg,
              type: 'success',
            })
            this.showLocationOnMap = false
          } else {
            this.$message({
              message: res.data.errmsg,
              type: 'error',
            })
          }
        })
    },

    closeSubmitPOI() {
      this.showLocationOnMap = false
    },
    addSkuItem() {
      // 打开 添加【套餐】对话框
      this.addSkuFormVisible = true
    },
    // 批量改库存的回调函数
    closeDealWithOk(value) {
      this.dialogAddStockPriceProp = false
    },
    changeBatchPrice() {
      // 批量改价 【对话框】
      if (this.stock_type == 1) {
        this.$message({
          type: 'warning',
          message: '该产品目前为固定库存，请在套餐中添加价格',
        })
      } else {
        this.dialogAddStockPriceProp = true
      }
    },
    // 关闭的回调
    closeAddSkuStock() {
      this.loading_up_price = false
    },
    creatOutSkuId() {
      // 添加套餐编号
      this.$http.get(`/creat_sku_out_id?spu_id=${this.spu_id}`).then((res) => {
        const { out_sku_id, errno, errmsg } = res.data
        if (errno == '0') {
          this.addSkuForm.out_sku_id = out_sku_id
        }
      })
    },
    changeOutSkuId() {
      // 修改套餐编号
      this.$http.get(`/creat_sku_out_id?spu_id=${this.spu_id}`).then((res) => {
        const { out_sku_id, errno, errmsg } = res.data
        if (errno == '0') {
          this.changePkgNameForm.out_sku_id = out_sku_id
        }
      })
    },
    changePkgNameConfirm() {
      this.$http
        .post('/product/sku/change_sku_name', this.changePkgNameForm)
        .then((res) => {
          const { errno, errmsg } = res.data

          if (errno == '0') {
            this.changePkgNameFormVisible = false
            this.changePkgNameForm.sku_id = ''
            this.changePkgNameForm.sku_name = ''
            this.changePkgNameForm.out_sku_id = ''
            this.$notify({
              title: '成功',
              message: '修改成功',
              type: 'success',
            })
          } else if (errno == '4003') {
            this.$notify({
              title: '错误',
              message: errmsg,
              type: 'warning',
            })
          }
        })
    },
    // 添加一个新的服务商
    confirmAddOperator(value) {
      this.$http.post('/product/change_operator_info', value).then((res) => {
        const { errno, errmsg } = res.data
        if (errno == '0') {
          // this.dialogOperatorInfo = false;
          this.showDialogOperatorInfo = false
          this.$notify({
            title: '成功',
            message: errmsg,
            type: 'success',
          })
          // 修改 父组件  信息
          this.getProductINtorduce(this.spu_id)
        } else if (errno == '4103') {
          this.$notify({
            title: '警告',
            message: errmsg,
            type: 'warning',
          })
        }
      })
    },
    // 选择一个服务商：
    choiceProductOperator(index, operator) {
      //
      this.$http
        .get(
          `/product/band_operator_info?spu_id=${this.spu_id}&operator_id=${operator.operator_id}`
        )
        .then((res) => {
          const { errno, errmsg } = res.data
          if (errno == '0') {
            this.$notify({
              title: '成功',
              message: errmsg,
              type: 'success',
            })
            this.showDialogOperatorInfo = false
            // 修改 父组件  信息
            this.getProductINtorduce(this.spu_id)
            // console.log(this.$parent.$parent);
            // this.$parent.$parent.$parent.getProductINtorduce();
          }
        })
    },
    // 添加 【可选套餐】提交
    addSkuFormConfirm() {
      let new_sku_info = {}
      let skus = []
      new_sku_info.spu_id = this.spu_id
      new_sku_info.out_sku_id = this.out_spu_id
      this.addSkuForm.sku_operation_type = 1
      skus.push(this.addSkuForm)
      new_sku_info.skus = skus
      // console.log(new_sku_info);
      this.$http.post('/product/sku/items/update', new_sku_info).then((res) => {
        const { errmsg, errno } = res.data
        if (errno == '0') {
          this.addSkuFormVisible = false
          location.reload()
          this.$notify({
            title: '成功',
            message: res.data.errmsg,
            type: 'success',
          })
        } else if (errno == '4004') {
          this.$notify({
            title: '注意',
            message: res.data.errmsg,
            type: 'warning',
          })
        }
      })
    },
    //  取消提交(关闭或点击遮挡)
    closeAddSkuForm() {
      this.addSkuFormCancle('addSkuDialog')
    },
    //  取消提交(点击取消按钮)
    addSkuFormCancle(formName) {
      this.$refs[formName].resetFields()
      //!!!!!!  要给 表单中的 表单块添加 prop="绑定值"  才可以
      this.addSkuFormVisible = false
    },
    // 点击sku 【可选套餐】
    click_sku_name(id) {
      const id_str = id.toString()
      // console.log(id_str);
      document.getElementById(id_str).scrollIntoView({
        behavior: 'smooth', // 平滑过渡
        block: 'start', // 上边框与视窗顶部平齐。默认值
      })
    },
    //点击 编辑 修改【套餐介绍】
    editor_sku_info() {
      this.is_editor = true
    },
    // -----------------------------------  修改套餐介绍  下拉菜单   -----------------------------------
    selectResTemplate() {
      // 点击 修改 预定信息模版
      this.$http.get('/get_reservation_stencil').then((res) => {
        const { data, errmsg, errno } = res.data
        if (errno == '0') {
          let templateData_list = []
          for (let i of data) {
            // 构建对象
            const template_item = {}
            template_item.id = i.id
            template_item.template_name = i.template_name
            // 取出列表内容
            const item_template = i.template
            // 将template的字符串内容，变更为 对象
            let item_template_dict = new Function('return ' + item_template)()
            const item_template_list = []
            for (let item of item_template_dict) {
              item_template_list.push(item.name)
            }
            template_item.template = item_template_list
            // console.log(template_item);
            templateData_list.push(template_item)
          }

          this.templateData = templateData_list
        }
      })
    },
    // 提交新价格
    submitNewPriceForSku() {
      let post_item = {
        sku_id: this.change_price_sku_id,
        price: this.price * 100,
        sell_price: this.sell_price * 100,
        net_price: this.net_price * 100,
      }
      this.$http
        .post('/product/change_sku_fixed_price', post_item)
        .then((res) => {
          if (res.data.errno == '0') {
            this.$message({
              type: 'success',
              message: '保存成功',
            })
            this.getProductINtorduce(this.spu_id)
            this.handleCloseAddPriceForSkuDialog()
          } else {
            this.$message({
              type: 'error',
              message: res.data.errmsg,
            })
          }
        })
    },
    // 关闭 固定类型价格修改
    handleCloseAddPriceForSkuDialog() {
      this.addPriceForSkuDialog = false
      this.change_price_sku_id = null
      this.price = ''
      this.sell_price = ''
      this.net_price = ''
    },
    // 处理下拉菜单
    clickDropdownButtion(command) {
      //console.log(command); //对象
      if (command.command == 'deleteSku') {
        // 删除该套餐将会同时删掉与之相关的套餐，请确认。
        this.$prompt('删除需要权限,请输入密码', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputErrorMessage: '密码不正确',
        })
          .then(({ value }) => {
            let pass = '@###¥%##DASDw'
            if (value == '') {
              this.$message({
                message: '请输入密码验证权限',
                type: 'error',
              })
            } else {
              if (value == pass) {
                this.$http
                  .get(`/product/delete_sku?sku_id=${command.id}`)
                  .then((res) => {
                    if (res.data.errno == '0') {
                      this.$message({
                        message: '已删除该套餐',
                        type: 'success',
                      })
                      // 刷新
                      this.getProductINtorduce(this.spu_id)
                    }
                  })
              } else {
                this.$message({
                  message: '验证不通过',
                  type: 'error',
                })
              }
            }
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '取消删除',
            })
          })
      }
      if (command.command == 'changePkgName') {
        //console.log(this.skus);
        this.changePkgNameFormVisible = true
        this.skus.forEach((i, index) => {
          if (i.sku_id == command.id) {
            this.changePkgNameForm.sku_id = i.sku_id
            this.changePkgNameForm.sku_name = i.sku_name
            this.changePkgNameForm.out_sku_id = i.out_sku_id
          }
        })
      }
      // 添加固定价格
      if (command.command == 'addPriceForSku') {
        console.log('修改/添加价格')
        // 判断 价格类型 是固定 还是日历
        if (this.stock_type == 0) {
          this.$message({
            type: 'warning',
            message: '当前为日历库存，请选择批量编辑库存',
          })
        } else {
          this.change_price_sku_id = command.id
          // 如果是固定，获取价格,填充给价格表
          this.$http
            .get(`/product/get_sku_fixed_price?sku_id=${command.id}`)
            .then((res) => {
              console.log(res)
              if (res.data.errno == '0') {
                this.price = (res.data.price / 100).toFixed(2)
                this.sell_price = (res.data.sell_price / 100).toFixed(2)
                this.net_price = (res.data.net_price / 100).toFixed(2)
              }
            })
        }

        let sku_id = command.id
        this.addPriceForSkuDialog = true
      }
      // 下架/上海
      if (command.command == 'changeSkuStauts') {
        //

        for (let i of this.skus) {
          if (i.sku_id == command.id) {
            this.$http
              .get(`/product/change_sku_status?sku_id=${command.id}`)
              .then((res) => {
                console.log(res)
                if (res.data.errno == '0') {
                  for (let i of this.skus) {
                    if (i.sku_id == command.id) {
                      i.sku_status = res.data.sku_status
                      this.$notify({
                        title: '成功',
                        message: res.data.errmsg + '，已' + res.data.sku_status,
                        type: 'success',
                      })
                    }
                  }
                } else {
                  this.$notify({
                    title: '失败',
                    message: res.data.errmsg,
                    type: 'danger',
                  })
                }
              })
          }
        }
      }
      // 绑定出行人信息模版
      if (command.command == 'bandTravellerInfo') {
        for (let i of this.skus) {
          if (i.sku_id == command.id) {
            this.band_sku_id = i.sku_id
            this.showTravellerTemplate = true
            this.$http
              .get(`/product/get_traveller_template?sku_id=${command.id}`)
              .then((res) => {
                const { data, errno, errmsg } = res.data

                if (data != undefined) {
                  this.template_name = data[0].template_name
                  if (data[0].mustFillIn == false) {
                    this.template_must_fill_in = '否'
                  } else {
                    this.template_must_fill_in = '是'
                  }
                  if (data[0].fillInOneOrEveryOne == false) {
                    this.template_one_everyone = '一人多份'
                  } else {
                    this.template_one_everyone = '一人一份'
                  }

                  this.band_traveller_template_id = data[0].id
                  let template_content = new Function(
                    'return ' + data[0].template
                  )()
                  let template_item_name = []
                  for (let item of template_content) {
                    template_item_name.push(item.name)
                  }
                  this.traveller_template_checked = template_item_name
                }
              })
          }
        }
      }
      // 绑定预定信息模版
      if (command.command == 'bandResTemplate') {
        for (let i of this.skus) {
          if (i.sku_id == command.id) {
            this.band_sku_id = i.sku_id
            // 通过套餐ID，来获取模版id
            this.$http
              .get(`/product/get_reservation_stencil?sku_id=${i.sku_id}`)
              .then((res) => {
                this.band_res_template_id = res.data.data
                // 获取模版内容
                this.$http
                  .get(
                    `/get_reservation_stencil?id=${this.band_res_template_id}`
                  )
                  .then((res) => {
                    const { data, errno, errmsg } = res.data
                    if (errno == '0') {
                      // 打开绑定模版对话框
                      this.bandResTemplateVisible = true
                      // 赋值组件的数据
                      let newData = new Function('return' + data[0].template)()
                      this.res_template_checked = newData
                    }
                    if (errno == '4001') {
                    }
                    if (errno == '4002') {
                      // 打开绑定模版对话框 ，没有数据
                      this.bandResTemplateVisible = true
                      // 赋值组件数据内容为空
                      this.res_template_checked = []
                    }
                  })
              })
          }
        }
      }
      for (let i of this.$refs.addTag) {
        if (i.attribuite == command) {
          i.haveTags = true
          i.showAddAndEdit = true
        }
      }
    },
    saveConfirmInfo(content, sku_id) {
      //修改套餐的预定须知
      this.$http
        .post('/product/sku/change_confirm_info', {
          sku_id: sku_id,
          confirm_info: content,
        })
        .then((res) => {
          if (res.data.errno == '0') {
            this.$notify({
              title: '成功',
              message: res.data.errmsg,
              type: 'success',
            })
            for (let i of this.skus) {
              if (i.sku_id == sku_id) {
                i.confirm_info = content
              }
            }
          } else if (res.data.errno !== '0') {
            this.$notify.error({
              title: '错误',
              message: res.data.errmsg,
            })
          }
        })
    },
    saveSkuInfoButton(content, sku_id) {
      //点击保存 【套餐介绍】：spu_id，skus[]，sku_operation_type=3，
      let spu_item = {}
      spu_item.sku_id = sku_id
      spu_item.spu_id = this.spu_id
      spu_item.sku_info = content
      this.$http.post('/product/sku/change_sku_info', spu_item).then((res) => {
        if (res.data.errno == '0') {
          this.$notify({
            title: '成功',
            message: res.data.errmsg,
            type: 'success',
          })
          for (let i of this.skus) {
            if (i.sku_id == sku_id) {
              i.sku_info = content
            }
          }
        } else if (res.data.errno !== '0') {
          this.$notify.error({
            title: '错误',
            message: res.data.errmsg,
          })
        }
      })
    },
    showRefundChoice() {
      //点击 修改退改原则
      this.$http.get('/product/get_refund_info').then((res) => {
        const { data, errmsg, errno } = res.data
        if (errno == '0') {
          this.refund_data_list = data
        }
      })
    },
    saveFeeIncludeButton(content, sku_id) {
      // 修改费用包含
      let spu_item = {}
      spu_item.sku_id = sku_id
      spu_item.spu_id = this.spu_id
      spu_item.fee_include = content
      this.$http
        .post('/product/sku/change_fee_include', spu_item)
        .then((res) => {
          if (res.data.errno == '0') {
            this.$notify({
              title: '成功',
              message: res.data.errmsg,
              type: 'success',
            })
            for (let i of this.skus) {
              if (i.sku_id == sku_id) {
                i.fee_include = content
                // console.log(i.fee_include);
                // console.log(content);
              }
            }
          }
        })
    },

    handleLogout() {
      this.$http.delete('/session').then((res) => {
        this.$router.push({ path: '/login' })
      })
    },
    handleLogin() {
      this.$router.push({ path: '/register' })
    },
    // 获取产品 信息
    getProductINtorduce(spu_id) {
      // console.log(this.$route.params.id);路由参数
      // 发送请求
      this.$http.get(`/product/get_product?spu_id=${spu_id}`).then((res) => {
        const { data, errmsg, errno } = res.data
        // 产品信息的对应
        this.spu_name = data.spu_name
        this.spu_id = data.id
        this.spu_image = data.spu_image
        this.out_spu_id = data.out_spu_id
        this.spu_dest = data.dest
        this.spu_dest_id = data.spu_dest_id
        this.spu_dest_pid = data.spu_dest_pid
        this.spu_detail = data.spu_detail
        this.stock_type = data.stock_type
        // 操作上的对应,如果没有操作商的信息
        if (data.operator_info == null) {
          this.operator_info_has = true
          this.operator_avatar = ''
        } else {
          this.operator_info_has = false
          this.operator_avatar = data.operator_info.operator_avatar
          this.operator_url = data.operator_info.operator_avatar
          this.operator_info.operator_name = data.operator_info.operator_name
          this.operator_info.operator_mobile =
            data.operator_info.operator_mobile
          this.operator_info.operator_loc_name =
            data.operator_info.operator_loc_name
          this.operator_info.operator_dest = data.operator_info.operator_dest
          this.operator_info.operator_address =
            data.operator_info.operator_address
          this.operator_info.operator_manager =
            data.operator_info.operator_manager
          this.operator_info.operator_intro = data.operator_info.operator_intro
        }
        // 套餐的对应
        this.skus = data.skus
        // console.log(this.skus);
      })
    },
  },
}
</script>

<style>
html {
  height: 100%;
}

body {
  height: 100%;
  /* background-color: rgb(158, 151, 149); */
}

.content-left-info {
  padding: 5px 5px;
  font-size: 13px;
}

.content-left-operate {
  padding: 5px 5px;
  font-size: 13px;
}

.product-intro-container {
  height: 100%;
  /* height: 500px; */
}

.account {
  line-height: 40px;
}

.el-menu .el-submenu .el-menu-item {
  min-width: 180px;
}

.el-card__header {
  font-size: 13px;
  padding: 5px 10px;
}

.header-product-title {
  padding: 5px;
}

/* .main-background {
  width: 100%;
  height: 100%;
  background-color: rgb(241, 236, 235);
} */

.main-background {
  /* display: flex; */
  height: 100vh;
  width: 100%;
  /* padding: 0 5px; */
  /* margin: 15px auto; */
  align-content: center;
  justify-content: center;
  background-color: rgb(241, 236, 235);
}

.product-intro-header {
  height: 80px;
  width: 100%;
  background-color: white;
  border-top: 4px solid #ff5421;
  box-shadow: 3px 0 3px rgba(0, 0, 0, 0.3);
  position: fixed;
}

.product_aside {
  /* display: block; */
  margin-top: 80px;
  margin-bottom: 5px;
  float: left;
  /* background-color: rgba(0, 0, 0, 0.1); */
  padding: 0 20px 0 15px;
  /* border: 1px solid #e5e9f2; */
  border-radius: 3px;
  /* flex: 0 0; */
  overflow: auto;
}

.product_intro_contain {
  display: block;
  margin-top: 80px;
  margin-bottom: 5px;
  padding: 0 15px 0px 0px;
  /* width: 1000px; */
  width: 75%;
  flex: initial;
  overflow: auto;
}

.product-intro-footer {
  background-color: #ff5421;
  /* position: absolute; */
  bottom: 0;
  height: 5%;
  width: 100%;
  position: absolute;
}

.nickname {
  display: inline-block;
  overflow: hidden;
  margin-left: 20px;
  font-size: medium;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 150px;
}

.logout {
  display: block;
}

.aside {
  display: block;
  height: auto;
  background-color: rgba(0, 0, 0, 0);
  margin-right: 15px;
  border: 0px;
  border-radius: 3px;
  flex: 0 0;
}

.select_skus_item {
  cursor: pointer;
  margin: 10px 0;
}

.additional_style {
  color: darkgray;
  font-size: 10px;
}

.dest-tag {
  color: white;
  background-color: tomato;
  padding: 3px 10px;
  border-radius: 5px;
}

.product_introduce {
  border: 0px solid rgba(255, 255, 255, 0.5);
  margin-top: 5px;
  cursor: pointer;
  overflow: hidden;
  /*设置超出的部分进行影藏*/
  text-overflow: ellipsis;
  /*设置超出部分使用省略号*/
  white-space: nowrap;
}

.main_product_info {
  margin-bottom: 10px;
}

.add-price-stock-title {
  background-color: lightgray;
  padding: 10px;
  margin-bottom: 5px;
}

.dialog-add-stock-price {
  padding: 0px 10px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #ff5421;
}

.el-divider__text {
  background-color: rgb(241, 236, 235);
  color: rgb(177, 177, 177);
}

/* .el-card.main_product_info.is-never-shadow .el-card__header {
    border-bottom: 3px solid #ff5421;
  } */

.el-card.card-header-style .el-card__header {
  background-color: #ff5421;
  color: white;
}
.package_price_area {
  background-color: #ff5421;
  padding: 10px;
  border-radius: 10px;
  color: #fff;
  font-weight: bolder;
}
</style>